import './footer.scss';

function Footer (){
var date = new Date()
return (     
<footer>
  <div className="copyright">
    <p>© {date.getFullYear()} - Kochetkov IN</p>
  </div>
  <div className="social">
    <a href="mailto:mut.e@icloud.com" className="support">Email</a>
    <a href="https://www.linkedin.com/in/igor-kochetkov-456167203/" className="linked">In</a>
  </div>
</footer>
    );
}

export default Footer;